import { gql } from '@apollo/client'

export const GET_PAGE_TAGS = gql`
  query GET_PAGE_TAGS {
    findManyPageTag {
      id
      slug
      page_tag_profiles {
        id
        language
        name
      }
    }
  }
`

export const UPSERT_PAGE_TAG = gql`
  mutation UPSERT_PAGE_TAG(
    $id: Int
    $page_tag_profiles: [PageTagProfileCustomInput!]!
    $slug: String
  ) {
    upsertPageTag(
      id: $id
      page_tag_profiles: $page_tag_profiles
      slug: $slug
    ) {
      id
      slug
      page_tag_profiles {
        id
        language
        name
      }
    }
  }
`

export const DELETE_PAGE_TAG = gql`
  mutation DELETE_PAGE_TAG($where: PageTagWhereUniqueInput!) {
    deleteOnePageTag(where: $where) {
      id
    }
  }
`
